import React, { useState, useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import './StoryViewModal.css';

const StoryViewModal = ({ userStories, onClose }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [progress, setProgress] = useState(0);

    const currentStory = userStories.allStories[currentIndex];

    useEffect(() => {
        if (!currentStory) return;

        const duration = 5000; // 5 seconds per story
        const interval = 50; // Update every 50ms
        const step = (interval / duration) * 100;

        const timer = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 100) {
                    handleNext();
                    return 0;
                }
                return prev + step;
            });
        }, interval);

        return () => clearInterval(timer);
    }, [currentIndex, currentStory]);

    const handleNext = () => {
        if (currentIndex < userStories.allStories.length - 1) {
            setCurrentIndex(currentIndex + 1);
            setProgress(0);
        } else {
            onClose();
        }
    };

    const handleBack = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            setProgress(0);
        }
    };

    if (!currentStory) return null;

    return (
        <div className="story-view-overlay">
            <div className="story-view-container">
                {/* Progress Bars */}
                <div className="story-progress-container">
                    {userStories.allStories.map((_, index) => (
                        <div key={index} className="progress-bar-bg">
                            <div
                                className="progress-bar-fill"
                                style={{
                                    width: index === currentIndex ? `${progress}%` : index < currentIndex ? '100%' : '0%'
                                }}
                            />
                        </div>
                    ))}
                </div>

                {/* Header */}
                <div className="view-header">
                    <div className="view-user-info">
                        <img src={userStories.userPhoto || 'https://api.dicebear.com/7.x/avataaars/svg?seed=' + userStories.uid} alt="" className="view-user-photo" />
                        <span className="view-user-name">{userStories.userName}</span>
                    </div>
                    <button onClick={onClose} className="view-close-btn">
                        <X size={28} color="white" />
                    </button>
                </div>

                {/* Content */}
                <div className="view-content" onClick={(e) => {
                    const width = e.currentTarget.offsetWidth;
                    const x = e.nativeEvent.offsetX;
                    if (x < width / 3) handleBack();
                    else handleNext();
                }}>
                    {currentStory.mediaType === 'video' ? (
                        <video
                            src={currentStory.mediaUrl}
                            autoPlay
                            playsInline
                            className="story-media"
                            onEnded={handleNext}
                        />
                    ) : (
                        <img src={currentStory.mediaUrl} alt="" className="story-media" />
                    )}
                </div>

                {/* Navigation Buttons for desktop/large screens */}
                <button className="nav-btn prev" onClick={(e) => { e.stopPropagation(); handleBack(); }} disabled={currentIndex === 0}>
                    <ChevronLeft size={32} />
                </button>
                <button className="nav-btn next" onClick={(e) => { e.stopPropagation(); handleNext(); }}>
                    <ChevronRight size={32} />
                </button>
            </div>
        </div>
    );
};

export default StoryViewModal;
